import { rdEquipamentosService } from '@/services/quotes/rd-equipamentos';
import { useQuery } from '@tanstack/react-query';

/**
 * Detalhes da proposta RD Equipamentos (`GET /:proposalId`).
 * `staleTime`/`gcTime` zerados + `refetchOnMount: 'always'` espelham
 * `use-proposal-details.hook.ts` (homeowner/capital-global): o wizard
 * sempre precisa do estado mais recente da proposta ao montar cada step.
 */
export function useRdProposal(proposalId: string | undefined) {
  return useQuery({
    queryKey: ['rd-proposal', proposalId],
    queryFn: async () => {
      if (!proposalId) {
        throw new Error('ProposalId é obrigatório');
      }

      const response = await rdEquipamentosService.getProposal(proposalId);
      if (!response.success || !response.data) {
        throw new Error(response.error || 'Erro ao carregar proposta');
      }

      return response.data;
    },
    enabled: !!proposalId,
    staleTime: 0,
    gcTime: 0,
    refetchOnMount: 'always',
  });
}
